// Screens are made in two steps: pick a type, then edit and publish. End screens have
// one type, so they only use the second step.
const screensSteps = [
  {
    title: 'Type',
  },
  {
    title: 'Edit and publish',
  },
];

export default screensSteps;

export const collectionsSteps = [
  {
    title: 'Add Context',
  },
  {
    title: 'Crawl',
  },
  {
    title: 'Publish',
  },
];
